import React from 'react';
import Link from '../components/common/Link';

const NotFoundPage = () => {
  return (
    <div className="container" style={{ padding: '100px 20px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '100px', fontWeight: 'bold', color: '#000000', marginTop: '40px' }}>404</h1>
      <h2 style={{ fontSize: '32px', marginTop: '20px' }}>페이지를 찾을 수 없습니다</h2>
      <p style={{ fontSize: '16px', color: '#666', margin: '20px 0 10px' }}>
        요청하신 페이지가 존재하지 않거나 잘못된 경로입니다.
      </p>
      <p style={{ fontSize: '16px', color: '#666', margin: '0px 0 40px' }}>
        올바른 URL을 입력했는지 확인해 주세요.
      </p>
      <Link to="/" style={{ border: '1px solid #000000', padding: '10px 20px', borderRadius: '5px', color: '#000000', textDecoration: 'none' }}>홈으로 돌아가기</Link>
    </div>
  );
};

export default NotFoundPage;